/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * showcan API
 * OpenAPI spec version: 1.0.0
 */
import type {
  PublicGeminiChatSessionResponse,
  PublicGeminiChatbotResponse,
} from "../../model";

import { customClient } from "../../custom-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get the public configuration of a Gemini voice chatbot (no auth required)
 * @summary Get Gemini chatbot config
 */
export const getGetPublicGeminiChatbotUrl = (agentId: string) => {
  return `/api/v1/public/gemini-chatbots/${agentId}`;
};

export const getPublicGeminiChatbot = async (
  agentId: string,
  options?: RequestInit,
): Promise<PublicGeminiChatbotResponse> => {
  return customClient<PublicGeminiChatbotResponse>(
    getGetPublicGeminiChatbotUrl(agentId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Create a session. The returned session ID authenticates the WebSocket connection.
 * @summary Create a Gemini chat session
 */
export const getCreatePublicGeminiChatSessionUrl = (agentId: string) => {
  return `/api/v1/public/gemini-chatbots/${agentId}/sessions`;
};

export const createPublicGeminiChatSession = async (
  agentId: string,
  options?: RequestInit,
): Promise<PublicGeminiChatSessionResponse> => {
  return customClient<PublicGeminiChatSessionResponse>(
    getCreatePublicGeminiChatSessionUrl(agentId),
    {
      ...options,
      method: "POST",
    },
  );
};
